import Vue from "vue";
import Vuex from "vuex";
import map from "./modules/map";
import clusters from "./modules/clusters";
import auth from "./modules/auth";
import graphics from "./modules/graphics";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  getters: {},
  modules: {
    map,
    clusters,
    auth,
    graphics
  }
});
